import { Collection, CreateCollectionConfig, DefaultItem } from '../collection';
import type { Agile } from '../../agile';
import { shared } from '../../shared';

/**
 * Returns a newly created Collection.
 *
 * A Collection manages a reactive set of Information
 * that we need to remember globally at a later point in time.
 * While providing a toolkit to use and mutate this set of Information.
 *
 * It is designed for arrays of data objects following the same pattern.
 *
 * Each of these data object must have a unique `primaryKey` to be correctly identified later.
 *
 * You can create as many global Collections as you need.
 *
 * [Learn more..](https://agile-ts.org/docs/core/agile-instance/methods#createcollection)
 *
 * @public
 * @param config - Configuration object
 * @param agileInstance - Instance of Agile the Collection belongs to.
 */
export function createCollection<DataType extends DefaultItem = DefaultItem>(
  config?: CreateCollectionConfig<DataType>,
  agileInstance: Agile = shared
): Collection<DataType> {
  return new Collection<DataType>(agileInstance, config);
}
